import { render, staticRenderFns } from "./personholiday.vue?vue&type=template&id=57449f42&scoped=true&"
import script from "./personholiday.vue?vue&type=script&lang=js&"
export * from "./personholiday.vue?vue&type=script&lang=js&"
import style0 from "./personholiday.vue?vue&type=style&index=0&id=57449f42&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57449f42",
  null
  
)

export default component.exports